import React, { useCallback, useState } from "react";
import { Card, Space, Form, Input, Button, Typography, message } from "antd";
import { connect } from "dva";
import { isEmpty } from "lodash";
import { router } from "umi";
import { Validator } from "@/utils/validator";
import styles from "./MaintenanceBanner.less";

const { Title, Text, Link } = Typography;

const MaintenanceBanner = ({ dispatch, isLoading, userManager }) => {
  const [form] = Form.useForm();
  const [showAdvanced, setShowAdvanced] = useState(false);

  const onSubmit = useCallback(({ devKey }) => {
    dispatch({
      type: "configs/validateDevKey",
      payload: devKey,
    })
      .then(response => {
        if (response?.error) {
          message.error("Invalid dev key");
          return;
        }

        // check if user is logged in
        const haveUser = !isEmpty(userManager);
        router.push(haveUser ? "/" : "/user/login");
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  return (
    <div className={styles.maintenanceContainer}>
      <Card className={styles.maintenanceCard}>
        <Space direction="vertical" align="center" size="large">
          <img src="/img/autosled-logo.png" alt="Autosled Logo" className={styles.maintenanceIcon} />
          <Title level={2} className={styles.maintenanceTitle}>
            Maintenance Mode
          </Title>
          <Text type="secondary" className={styles.maintenanceText}>
            Our system is currently undergoing maintenance. We&apos;ll be back soon.
          </Text>

          <Link onClick={() => setShowAdvanced(prev => !prev)}>
            {showAdvanced ? "Hide Advanced Settings" : "Advanced Settings"}
          </Link>

          {showAdvanced && (
            <div className={styles.inputContainer}>
              <Form form={form} layout="inline" onFinish={onSubmit}>
                <Form.Item name="devKey" rules={[Validator.required("The key is required")]}>
                  <Input.Password
                    placeholder="Enter Developer Key"
                    className={styles.maintenanceInput}
                    autoComplete="off"
                  />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={isLoading}>
                    Login as Dev
                  </Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default connect(({ configs, loading, user }) => ({
  configMaintenanceMode: configs.configMaintenanceMode,
  isLoading: loading.effects["configs/validateDevKey"],
  userManager: user.userManager,
}))(MaintenanceBanner);
